import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledSvgIcon = styled(BaseSvg)`
  color: #cccccc;
  width: 16px;
  height: 16px;

  /* TODO Remove this and colorize with the surrounding button */
  &:hover {
    color: #aaaaaa;
  }
`

// TODO Remove the onClick and disabled!
const Delete = ({
  disabled,
  onClick,
  title = 'Delete',
  ...rest
}: IconProps & { onClick?: (e: Event) => void; disabled?: boolean }) => (
  // @ts-expect-error
  <StyledSvgIcon disabled={disabled} onClick={onClick} viewBox="0 0 16 16" title={title} {...rest}>
    <g>
      <path
        fill="currentColor"
        d="M15.652 2.667H11.13V.333A.34.34 0 0 0 10.783 0H5.217a.34.34 0 0 0-.347.333v2.334H.348A.34.34 0 0 0 0 3v.667A.34.34 0 0 0 .348 4h15.304A.34.34 0 0 0 16 3.667V3a.34.34 0 0 0-.348-.333zm-10.087-2h4.87v2h-4.87v-2zM14.667 5.333h-12v10c0 .369.316.667.706.667H13.96c.39 0 .706-.298.706-.667v-10zM6.197 13a.343.343 0 0 1-.354.333A.343.343 0 0 1 5.49 13V8.333c0-.184.158-.333.353-.333.195 0 .353.15.353.333V13zm2.823 0a.343.343 0 0 1-.353.333.343.343 0 0 1-.353-.333V8.333c0-.184.157-.333.353-.333.195 0 .353.15.353.333V13zm2.823 0a.343.343 0 0 1-.353.333.343.343 0 0 1-.353-.333V8.333c0-.184.158-.333.353-.333.195 0 .353.15.353.333V13z"
      />
    </g>
  </StyledSvgIcon>
)

Delete.displayName = 'Delete'
Delete.needsWork = true
export default Delete
